import React, { useEffect, useState } from 'react';
import { InView } from 'react-intersection-observer';
import { isClient, getSessionStorageItem } from '@pegasus/utils';
// eslint-disable-next-line import/no-unresolved
import { deleteCookie, setCookie } from '@client/helpers/cookie';
// eslint-disable-next-line import/no-unresolved
import { track } from '@client/helpers/tracking';
import { getPropertiesFromBrazeCard, CardMethodsFromBraze, ClassicCard } from '@pegasus/braze';
import { Message, MessagePurpose, MessageType } from '@lux/message';
import { removeSessionStorageItem, setTodayDateAtMidnight } from '../helpers';

interface Props {
    cardToRender: ClassicCard;
    cardMethodsFromBraze: CardMethodsFromBraze;
}

export const BrazeBanner: React.FC<Props> = ({ cardToRender, cardMethodsFromBraze }) => {
    const [showCard, setShowCard] = useState(false);

    const itemCard = getPropertiesFromBrazeCard(cardToRender);

    const dismissedCardIdFromSessionStorage =
        isClient() && getSessionStorageItem('dismissed_braze_card_id_for_session');
    // TODO: this as method to ensure that we show the banner only for desired dismissed card
    useEffect(() => {
        if (
            dismissedCardIdFromSessionStorage &&
            dismissedCardIdFromSessionStorage === cardToRender.id
        ) {
            setShowCard(true);
        }
    }, [dismissedCardIdFromSessionStorage, cardToRender.id]);

    const { footNote, addInfo } = itemCard.extras;
    const trackingPayload = {
        cardContentId: cardToRender.id as string, // id comes as option from Braze type, hence the need for casting
        brazeVoucher: itemCard.brazeVoucher,
        brazeVoucherExpire: itemCard.brazeVoucherExpire,
        location: 'cart_mylounge',
        addInfo,
    };

    const { logCardClick } = cardMethodsFromBraze;

    const trackImpression = (inView: boolean) => {
        if (inView) {
            track('braze_web_contentCard_shown', trackingPayload);
        }
    };

    const todayDateAtMidnight = setTodayDateAtMidnight();
    const handleCtaClickAndCommunicateToBraze = () => {
        setShowCard(false);
        logCardClick(cardToRender, true);
        track('braze_web_contentCard_CTAClick', trackingPayload);
        if (isClient()) {
            removeSessionStorageItem('brazeCardToRender');
            removeSessionStorageItem('dismissed_braze_card_id_for_session');
            removeSessionStorageItem('show_braze_voucher_dismissed');
        }

        deleteCookie('show_braze_banner');

        // @ts-expect-error
        setCookie('is_braze_experience_checkout', 'true', todayDateAtMidnight.toUTCString(), '/');

        window.location.assign(`${itemCard.url}&brazeVoucher=true`);
    };

    return (
        showCard && (
            <InView
                as="div"
                onChange={inView => trackImpression(inView)}
                triggerOnce
                threshold={0.9}
            >
                <Message
                    type={MessageType.INLINE}
                    purpose={MessagePurpose.COMMERCIAL}
                    title={itemCard.title}
                    onLinkClick={handleCtaClickAndCommunicateToBraze}
                    linkText={itemCard.ctaText}
                    footerText={footNote}
                >
                    {itemCard.message}
                </Message>
            </InView>
        )
    );
};
